// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__L5-KK","content":"styles_content__3-L9o","row":"styles_row__1YfBu","footer":"styles_footer__2ry3N","phraseLength":"styles_phraseLength__2W5r5"};